import spartaCinemaUtility from '@sparta.global.utilities/cinema-utility/dist/es6.js';
import Utility from '@sparta.sales.utilities/module-utils-utility/dist/es6.js';
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import $ from '@sparta.global.vendors/jquery';
import Handlebars from '@sparta.global.vendors/handlebars';
import { cinemaHelper } from '@sparta.global.helpers/cinema-helper/dist/es6.js';
import { compare } from '@sparta.global.helpers/comparisons-helper/dist/es6.js';

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<section class=\"wrapper-video-module"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depths[1] != null ? lookupProperty(depths[1],"module") : depths[1])) != null ? lookupProperty(stack1,"skin") : stack1),{"name":"if","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":36},"end":{"line":2,"column":124}}})) != null ? stack1 : "")
    + "\" data-multiple=\"false\">\r\n  <div class=\"row\">\r\n    <div class=\"small-12 medium-12 column\">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"header") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":5,"column":6},"end":{"line":7,"column":13}}})) != null ? stack1 : "")
    + "      <div class=\"row\">\r\n        <div class=\"intro large-10 medium-12\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"intro") || (depth0 != null ? lookupProperty(depth0,"intro") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"intro","hash":{},"data":data,"loc":{"start":{"line":9,"column":46},"end":{"line":9,"column":59}}}) : helper))) != null ? stack1 : "")
    + "</div>\r\n      </div>\r\n      <div class=\"row\">\r\n        <div class=\"medium-8 small-12 column centered\">\r\n          <div class=\"cinema-example\"> "
    + ((stack1 = (lookupProperty(helpers,"cinemaHelper")||(depth0 && lookupProperty(depth0,"cinemaHelper"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"video") : depth0),{"name":"cinemaHelper","hash":{},"data":data,"loc":{"start":{"line":13,"column":39},"end":{"line":13,"column":65}}})) != null ? stack1 : "")
    + " </div>\r\n        </div>\r\n      </div>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"bottomNote") : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":16,"column":6},"end":{"line":20,"column":13}}})) != null ? stack1 : "")
    + "    </div>\r\n  </div>\r\n</section>\r\n";
},"2":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depths[1] != null ? lookupProperty(depths[1],"module") : depths[1])) != null ? lookupProperty(stack1,"skin") : stack1),"===","white",{"name":"compare","hash":{},"fn":container.program(3, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":58},"end":{"line":2,"column":117}}})) != null ? stack1 : "");
},"3":function(container,depth0,helpers,partials,data) {
    return " white";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <h3 class=\"header\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"header") || (depth0 != null ? lookupProperty(depth0,"header") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"header","hash":{},"data":data,"loc":{"start":{"line":6,"column":27},"end":{"line":6,"column":41}}}) : helper))) != null ? stack1 : "")
    + "</h3>\r\n";
},"7":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <div class=\"row\">\r\n        <div class=\"bottom-note large-10 medium-12\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"bottomNote") || (depth0 != null ? lookupProperty(depth0,"bottomNote") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"bottomNote","hash":{},"data":data,"loc":{"start":{"line":18,"column":52},"end":{"line":18,"column":68}}}) : helper))) != null ? stack1 : "")
    + "</div>\r\n      </div>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"local") : depth0)) != null ? lookupProperty(stack1,"content") : stack1),{"name":"with","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":24,"column":9}}})) != null ? stack1 : "");
},"useData":true,"useDepths":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.home-loans.modules/video-module",
  "version": "3.0.1",
  "id": "videoModule",
  "containerID": "homeLoansVideoModule",
  "moduleName": "home-loans-video-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "video-module",
  "data": {
    "init": "videoModule"
  },
  "moduleParams": [{
    "name": "scope",
    "type": "string",
    "default": "",
    "description": ""
  }, {
    "name": "skin",
    "type": "string",
    "default": "",
    "description": "Change the background color of the module. Use \"cool\" or \"white\""
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {
        cinemaHelper,
        compare
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    cinemaHelper,
    compare
  },
  "dependencies": {
    "@sparta.sales.utilities/module-utils-utility": "^1.0.0",
    "@sparta.global.helpers/cinema-helper": "^3.0.0",
    "@sparta.global.helpers/comparisons-helper": "^1.0.0",
    "@sparta.global.utilities/cinema-utility": "^3.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.vendors/jquery": "^3.2.1",
    "@sparta.global.vendors/lodash": "^4.17.21"
  },
  "stores": []
};

/**
 * @export
 * @class videoModule
 * @extends {Module}
 */
class videoModule extends Module {
  /**
   * Creates an instance of videoModule.
   * @param {Object} options Module Options
   * @param {Object} context Module Config
   * @memberof videoModule
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });

    // Jquery object for wrapper
    this.$target = $('#videoModule');
    this.$targetTwo = $('#video-module-home-equity');

    // bind this method
    this.bindAllMethod = Utility.bindAllMethod.bind(this);

    // then bind all methods
    this.bindAllMethod();
  }

  /**
   * @method fadeInModule
   * @returns {void}
   */
  fadeInModule() {
    // fade in
    this.$target.fadeIn(1000);
    this.$targetTwo.fadeIn(1000);

    // add class
    this.$target.addClass('todo-active');
    this.$targetTwo.addClass('todo-active');
  }

  /**
   * @method hideModule
   * @returns {void}
   */
  hideModule() {
    this.$target.addClass('hide');
    this.$targetTwo.addClass('hide');
  }

  /**
   * @method showModule
   * @returns {void}
   */
  showModule() {
    this.$target.removeClass('hide');
    this.$targetTwo.removeClass('hide');
  }

  /**
   * @method init
   * @returns {void}
   */
  init() {
    // Ignoring the spartaCinemaUtility video init again
    // if already video is initialized or page has more than one videos
    spartaCinemaUtility.init('videoContainer');
  }
}
registerModuleClass({
  moduleClass: videoModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { videoModule as default, moduleConfig };
